import { Component,ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController ,Content} from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { SelectCountryPage } from '../select-country/select-country';
import { SelectZonesPage } from '../select-zones/select-zones';
import { BillingAddressPage } from '../billing-address/billing-address';
import { ShippingMethodPage } from '../shipping-method/shipping-method';
import { ThankYouPage } from '../thank-you/thank-you';
import { FinancePage } from '../finance-offer/finance-offer';
import { TechSurveyPage } from '../tech-surveys/tech-surveys';


@Component({
  selector: 'create-tech-survey',
  templateUrl: 'create-tech-survey.html',
})


export class CreateTechSurveyPage {
  @ViewChild(Content) contentArea: Content;
  errorMessage = '';
addresses = new Array;
foundAddress: boolean = false;
postcode_search = '';
  surveyDetail = {};//include shipping address, billing address,  shipping methods.

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public config: ConfigProvider,
    public http: Http,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public loading: LoadingProvider, ) {
      // Appsee.startScreen("Address");


  }

setCommPrefs = function(prefs){
  console.log("Set Prefs:",prefs)

}

createSurvey  = function  (nonce){
  console.log("Create a Survey");
  console.log("Shared Data:",this.shared);
  this.surveyDetail = this.shared.orderDetails;;
  this.surveyDetail.customers_id = this.shared.customerData.customers_id;
  var data = this.surveyDetail;

  console.log("Data to Post:",JSON.stringify(data));
  this.http.post(this.config.url + 'createTechSurvey', data).map(res => res.json()).subscribe(data => {

      this.navCtrl.push(TechSurveyPage, { });
  });

}



  getAddress() {
    this.foundAddress = false;
    this.loading.show();
    console.log("Find Address:",this.postcode_search);
    var data: { [k: string]: any } = {};

    if(this.postcode_search == 'Test')
    {
    this.addresses = JSON.parse('[{"addressline1": "18 Test Street","summaryline": "18 Test Street, A Town, London, L16 6BS","number": "18","premise": "18","street": "Test Street","posttown": "A Town","county": "London","postcode": "L16 6BS"}]');
    console.log("Addresses:",data.addresses);
    this.loading.hide();
    this.contentArea.scrollToBottom(300);


    }
    else{
    data.postcode= this.postcode_search;

    this.http.post(this.config.url + 'getAddress', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      if (data.success == 1) {
        this.addresses = data.addresses;
      this.contentArea.scrollToBottom(300);



        }
      });
    }

    }
    setAddress(data){
      this.foundAddress = true;
      this.addresses = [];
      this.postcode_search = '';
      //console.log("Got Address:",data);
      this.shared.orderDetails.delivery_street_address = data.premise + ',' + data.street;
      this.shared.orderDetails.tax_zone_id = data.premise ;
      this.shared.orderDetails.delivery_zone = data.street;
      this.shared.orderDetails.delivery_city = data.posttown;
      this.shared.orderDetails.delivery_postcode = data.postcode;
      this.shared.orderDetails.delivery_state = data.county;

    }

  selectCountryPage() {
    let modal = this.modalCtrl.create(SelectCountryPage, { page: 'shipping' });
    modal.present();
  }
  selectZonePage() {
    let modal = this.modalCtrl.create(SelectZonesPage, { page: 'shipping', id: this.shared.orderDetails.delivery_country_id });
    modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/create-tech-survey/create-tech-survey.ts